import axios from '../axios'
// 单独导出
export const login = (data) => {
  return axios({
    url: '/con/user/login',
    method: 'POST',
    data: data
  })
}
export const changePASS = (data) => {
  return axios({
    url: '/con/user/modifyPassWord',
    method: 'POST',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/login.js